var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 28,
    viewBox: "0 0 220 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_15534)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_15534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3364 28L0.904297 19.9602L10.2765 13.9975L0.904297 8.0398L13.3364 0L15.226 2.91804L7.34323 8.01447L16.7559 13.9975L7.34323 19.9855L15.226 25.0769L13.3364 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6764 28L11.2393 19.9602L20.6165 13.9975L11.2393 8.0398L23.6764 0L25.561 2.91804L17.6833 8.01447L27.096 13.9975L17.6833 19.9855L25.561 25.0769L23.6764 28Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_15534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5579 1.6084H63.3877V26.3848H67.5579V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9231 1.6084H74.7529V26.3848H78.9231V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5795 11.2157L64.8018 15.2344L66.1484 19.1812L77.9262 15.1625L76.5795 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6487 1.6416H44V5.81181H58.6487V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4124 3.72656H49.2422V26.3582H53.4124V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8176 28L81.8096 13.1461L90.984 0L94.3996 2.38298L86.9396 13.0733L96.167 25.5177L92.8176 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4923 11.0283H84.3779V15.1985H94.4923V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_15534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.852 28L145.756 13.1476L155 0L158.443 2.38143L150.929 13.0746L160.227 25.5191L156.852 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.365 27.0649H112.167V5.11465L122.407 0.935547L124.005 4.78961L116.365 7.90735V27.0649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.341 12.0356L113.402 16.0537L115.134 19.8484L124.073 15.8302L122.341 12.0356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.141 27.038L125.99 14.3481L135.054 0.955078L144.579 13.7445L135.141 27.038ZM130.87 14.2486L135.128 20.3382L139.653 13.7511L135.215 8.19223L130.87 14.2552V14.2486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.842 27.3164L181.255 24.0262L187.198 19.4291L179.731 10.401L189.424 0.563477L192.425 3.48222L185.366 10.6464L193.167 20.0859L183.842 27.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.803 27.1774V0.736293H168V20.9088L173.649 18.5539L173.388 0.762827L177.586 0.703125L177.886 21.3068L163.803 27.1774Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_15534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_15534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1914,
    height: 28,
    fill: "white",
    transform: "translate(0.904297)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_15534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_15534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 28,
    fill: "white",
    transform: "translate(112.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFocus);
export default __webpack_public_path__ + "static/media/programFocus.298644c8f5af2754c17cdac60be60764.svg";
export { ForwardRef as ReactComponent };